<ng-container *ngIf="!inlineMode; else inlineEditor">
  <div class="page-container">
    <div class="header-section">
      <div class="title-block">
        <h1>
          {{ inspectionArticleId !== null ? 'Edit Article' : 'Create Article' }}
        </h1>
        <div class="subtitle">
          Separate area for article type, title, quantity, sizes and measurement matrix
        </div>
      </div>

      <div class="header-actions">
        <button type="button" class="btn-secondary" (click)="goBack()">
          <span class="material-icons">arrow_back</span>
          Back
        </button>

        <button type="button" class="btn-primary" (click)="saveArticle()">
          <span class="material-icons">save</span>
          Save
        </button>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="editorContent"></ng-container>
  </div>
</ng-container>

<ng-template #inlineEditor>
  <div class="article-inline-editor">
    <div class="article-inline-editor__header">
      <div class="title-block">
        <h3>
          {{ inspectionArticleId !== null ? 'Edit Article' : 'Create Article' }}
        </h3>
        <div class="subtitle">
          Edit article type, title, quantity, sizes and measurement matrix directly in this inspection.
        </div>
      </div>

      <div class="header-actions">
        <button type="button" class="btn-secondary" (click)="goBack()">
          <span class="material-icons">close</span>
          Cancel
        </button>

        <button type="button" class="btn-primary" (click)="saveArticle()">
          <span class="material-icons">save</span>
          Save
        </button>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="editorContent"></ng-container>
  </div>
</ng-template>

<ng-template #editorContent>
  <div *ngIf="loading" class="loading-container">
    <p-progressSpinner styleClass="labtech-spinner" ariaLabel="Loading"></p-progressSpinner>
    <p>Loading article...</p>
  </div>

  <div *ngIf="!loading" class="detail-container article-detail-page">
    <form>
      <div class="form-card">
        <div class="section-header">
          <span class="material-icons">inventory_2</span>
          <div>
            <h3 class="card-title mb-0">Article</h3>
            <p class="section-subtitle mb-0">
              Select the article type, set the title and quantity.
            </p>
          </div>
        </div>

        <div class="editor-form-grid">
          <div class="editor-fields-grid">
            <div class="form-group">
              <label class="form-label">Article Type <span class="required">*</span></label>
              <p-select [filter]="true"
                [options]="articleTypeList"
                [(ngModel)]="selectedArticleType"
                name="selectedArticleType"
                optionLabel="english"
               
               
               
                class="form-input"
                (ngModelChange)="onArticleTypeChange($event)"
              >
              </p-select>
            </div>

            <div class="form-group">
              <label class="form-label">Title <span class="required">*</span></label>
              <input
                pInputText
                [(ngModel)]="article.title"
                name="title"
                placeholder="Enter title"
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Quantity <span class="required">*</span></label>
              <p-inputNumber
                [(ngModel)]="article.quantity"
                name="quantity"
                [min]="1"
               
                class="form-input"
               [minFractionDigits]="0" [maxFractionDigits]="0">
              </p-inputNumber>
            </div>
          </div>

          <div class="preview-panel">
            <div class="preview-label">Image</div>

            <div class="preview-box" *ngIf="article.imageUrl; else noImagePreview">
              <img [src]="article.imageUrl" [alt]="article.title || 'Article image'" class="preview-image" />
            </div>

            <ng-template #noImagePreview>
              <div class="preview-box preview-box--empty">
                <span class="material-icons">image_not_supported</span>
                <span>No image available</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="section-header">
          <span class="material-icons">straighten</span>
          <div>
            <h3 class="card-title mb-0">Sizes</h3>
            <p class="section-subtitle mb-0">
              Searchable size list with selected chips and a scrollable overview.
            </p>
          </div>
        </div>

        <div *ngIf="articleSizeList.length === 0" class="compact-empty-state">
          <span class="material-icons">check_box_outline_blank</span>
          <div>
            <div class="empty-title">No sizes found</div>
            <div class="empty-text">There are currently no article sizes available.</div>
          </div>
        </div>

        <ng-container *ngIf="articleSizeList.length > 0">
          <div class="size-selection-toolbar">
            <div class="size-search-wrap">
              <label class="size-search-label" for="sizeSearch">Search sizes</label>
              <input
                id="sizeSearch"
                pInputText
                [(ngModel)]="sizeSearchText"
                (ngModelChange)="onSizeSearchChange()"
                name="sizeSearchText"
                placeholder="e.g. S, 38, XL, 116"
                class="form-input"
              />
            </div>

            <div class="size-selection-summary">
              <span class="size-selection-count">{{ selectedSizes.length }} selected</span>
              <span class="size-selection-text">{{ selectedSizeTitleList() }}</span>
            </div>
          </div>

          <div class="selected-size-chip-list" *ngIf="selectedSizes.length > 0">
            <button
              type="button"
              class="selected-size-chip"
              *ngFor="let size of selectedSizes; trackBy: trackBySelectedSizeId"
              (click)="removeSelectedSize(size.articleSizeId)"
            >
              <span>{{ size.sizeTitle }}</span>
              <span class="material-icons">close</span>
            </button>
          </div>

          <div class="available-size-panel">
            <div class="available-size-panel-header">
              <div>
                <div class="available-size-title">Available sizes</div>
                <div class="available-size-subtitle">
                  {{ visibleFilteredSizeRangeLabel() }} loaded
                </div>
              </div>
            </div>

            <div *ngIf="filteredArticleSizes().length === 0" class="compact-empty-state compact-empty-state--flat">
              <span class="material-icons">search_off</span>
              <div>
                <div class="empty-title">No sizes found</div>
                <div class="empty-text">Adjust the search term.</div>
              </div>
            </div>

            <div
              class="size-chip-list size-chip-list--scrollable"
              *ngIf="filteredArticleSizes().length > 0"
              (scroll)="onAvailableSizesScroll($event)"
            >
              <button
                type="button"
                class="size-chip"
                *ngFor="let size of visibleFilteredArticleSizes(); trackBy: trackByArticleSizeId"
                [class.selected]="isSizeSelected(size.articleSizeId)"
                (click)="toggleSize(size, !isSizeSelected(size.articleSizeId))"
              >
                <span>{{ size.title }}</span>
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="form-card">
        <div class="section-header">
          <span class="material-icons">table_chart</span>
          <div>
            <h3 class="card-title mb-0">Measurement Matrix</h3>
            <p class="section-subtitle mb-0">
              The desktop matrix keeps a clean visible window. Tolerances are prefilled and can be adjusted here.
            </p>
          </div>
        </div>

        <div
          *ngIf="!article.articleTypeId || selectedPoms.length === 0 || selectedSizes.length === 0"
          class="compact-empty-state"
        >
          <span class="material-icons">grid_off</span>
          <div>
            <div class="empty-title">Matrix not available yet</div>
            <div class="empty-text">
              Select an article type and at least one size.
            </div>
          </div>
        </div>

        <ng-container *ngIf="article.articleTypeId && selectedPoms.length > 0 && selectedSizes.length > 0">
          <div class="matrix-toolbar">
            <div class="matrix-summary-pill">{{ selectedPoms.length }} measurement points</div>
            <div class="matrix-summary-pill">{{ selectedSizes.length }} sizes</div>
            <div class="matrix-summary-pill matrix-summary-pill--muted">
              {{ selectedPoms.length * selectedSizes.length }} values
            </div>
          </div>

          <div class="matrix-window-toolbar" *ngIf="hasHiddenMatrixColumns()">
            <div class="matrix-window-copy">
              <div class="matrix-window-title">Visible sizes</div>
              <div class="matrix-window-subtitle">{{ currentMatrixRangeLabel() }}</div>
            </div>

            <div class="matrix-window-actions">
              <button
                type="button"
                class="btn-secondary btn-small"
                [disabled]="!canShowPreviousMatrixColumns()"
                (click)="showPreviousMatrixColumns()"
              >
                <span class="material-icons">chevron_left</span>
                Back
              </button>

              <button
                type="button"
                class="btn-secondary btn-small"
                [disabled]="!canShowNextMatrixColumns()"
                (click)="showNextMatrixColumns()"
              >
                Next
                <span class="material-icons">chevron_right</span>
              </button>
            </div>
          </div>

          <div class="matrix-wrap matrix-wrap--desktop">
            <table class="matrix-table">
              <colgroup>
                <col class="col-pom-de" />
                <col class="col-pom-en" />
                <col class="col-tolerance" />
                <col class="col-tolerance" />
                <col *ngFor="let size of visibleMatrixSizes; trackBy: trackBySelectedSizeId" class="col-size" />
              </colgroup>

              <thead>
                <tr>
                  <th class="pom-column pom-column-de">POM DE</th>
                  <th class="pom-column pom-column-en">POM EN</th>
                  <th class="tolerance-column">Tolerance +</th>
                  <th class="tolerance-column">Tolerance -</th>
                  <th *ngFor="let size of visibleMatrixSizes; trackBy: trackBySelectedSizeId" class="size-column">
                    {{ size.sizeTitle }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let pom of selectedPoms; trackBy: trackByPomId">
                  <td class="pom-cell pom-cell-de">{{ pom.titleDe || '-' }}</td>
                  <td class="pom-cell pom-cell-en">{{ pom.titleEn || '-' }}</td>
                  <td class="tolerance-cell">
                    <p-inputNumber
                      [(ngModel)]="pom.tolerancePlus"
                      [ngModelOptions]="{ standalone: true }"
                     
                     
                      [step]="0.1"
                      [min]="0"
                      class="matrix-input tolerance-input"
                     [minFractionDigits]="2" [maxFractionDigits]="2">
                    </p-inputNumber>
                  </td>
                  <td class="tolerance-cell">
                    <p-inputNumber
                      [(ngModel)]="pom.toleranceMinus"
                      [ngModelOptions]="{ standalone: true }"
                     
                     
                      [step]="0.1"
                      [min]="0"
                      class="matrix-input tolerance-input"
                     [minFractionDigits]="2" [maxFractionDigits]="2">
                    </p-inputNumber>
                  </td>

                  <td *ngFor="let size of visibleMatrixSizes; trackBy: trackBySelectedSizeId" class="matrix-value-cell">
                    <p-inputNumber
                      [ngModel]="getExpectedValue(pom.inspectionArticlePOMId, size.inspectionArticleSizeId)"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setExpectedValue(pom.inspectionArticlePOMId, size.inspectionArticleSizeId, $event)"
                     
                     
                      [step]="0.1"
                      class="matrix-input"
                     [minFractionDigits]="2" [maxFractionDigits]="2">
                    </p-inputNumber>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mobile-size-switcher">
            <div class="mobile-size-switcher-label">Active size</div>
            <p-select [filter]="true"
              [options]="selectedSizes"
              [(ngModel)]="mobileActiveSizeId"
              name="mobileActiveSizeId"
              optionLabel="sizeTitle"
              optionValue="inspectionArticleSizeId"
             
              class="form-input"
            >
            </p-select>
          </div>

          <div class="matrix-mobile-list" *ngIf="activeMobileSize() as activeSize">
            <div class="matrix-mobile-card" *ngFor="let pom of selectedPoms; trackBy: trackByPomId">
              <div class="matrix-mobile-card-header">
                <div>
                  <div class="matrix-mobile-title">{{ pom.titleDe || '-' }}</div>
                  <div class="matrix-mobile-subtitle">{{ pom.titleEn || '-' }}</div>
                </div>

              </div>

              <div class="matrix-mobile-inputs">
                <div class="matrix-mobile-tolerance-row">
                  <div class="matrix-mobile-tolerance-field">
                    <label class="matrix-mobile-tolerance-label">Tolerance +</label>
                    <p-inputNumber
                      [(ngModel)]="pom.tolerancePlus"
                      [ngModelOptions]="{ standalone: true }"
                     
                     
                      [step]="0.1"
                      [min]="0"
                      class="matrix-input matrix-input--mobile"
                     [minFractionDigits]="2" [maxFractionDigits]="2">
                    </p-inputNumber>
                  </div>

                  <div class="matrix-mobile-tolerance-field">
                    <label class="matrix-mobile-tolerance-label">Tolerance -</label>
                    <p-inputNumber
                      [(ngModel)]="pom.toleranceMinus"
                      [ngModelOptions]="{ standalone: true }"
                     
                     
                      [step]="0.1"
                      [min]="0"
                      class="matrix-input matrix-input--mobile"
                     [minFractionDigits]="2" [maxFractionDigits]="2">
                    </p-inputNumber>
                  </div>
                </div>

                <div class="matrix-mobile-input-row">
                  <label class="matrix-mobile-size-label">{{ activeSize.sizeTitle }}</label>

                  <p-inputNumber
                    [ngModel]="getExpectedValue(pom.inspectionArticlePOMId, activeSize.inspectionArticleSizeId)"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="setExpectedValue(pom.inspectionArticlePOMId, activeSize.inspectionArticleSizeId, $event)"
                   
                   
                    [step]="0.1"
                    class="matrix-input matrix-input--mobile"
                   [minFractionDigits]="2" [maxFractionDigits]="2">
                  </p-inputNumber>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
</ng-template>
